import styled, { css } from 'styled-components';
import theme from '../../../../styles/defaultTheme';

export const WarningMessage = styled.span`
    width: 100%;
    margin: 10px 0;
    padding: 0 16px;
`;

export const LinkCartilha = styled.a`
    width: 250px;
    height: 30px;
    margin-left: 40px;
    padding-left: 8px;
    text-align: left;
    text-decoration: underline;
    font: ${theme.font.body[3]};
    color: ${(props) => props.theme.orangeLink};

    span {
        font-size: ${theme.font.size16};
        text-decoration: underline;
        margin-right: 8px;

    }
    &:hover {
        color: ${(props) => props.theme.orangeLink};
        
        ${({ contrastTheme }) =>
            contrastTheme &&
            css`
            text-decoration: underline;
        `}
    }

    &:hover span {
        text-decoration: none;
        color: ${(props) => props.theme.orangeLink};

        ${({ contrastTheme }) =>
            contrastTheme &&
            css`
            text-decoration: underline;
        `}
    }
`;

export const SearchGroup = styled.div`
    display: flex;
    width: 100%;
    align-items: flex-end;

    .search-container {
        width: auto;
    }
`;
